<div class="alert-root" [class.show]="showAlert()">

  <div class="dialog-container">

    <!-- НЕОНОВАЯ ВИДЕО-РАМКА -->
    <div class="video-frame">
      <video #frameVideo1 class="frame-video active" muted playsinline preload="auto">
        <source src="assets/videos/donation-overlay.webm" type="video/webm">
      </video>

      <video #frameVideo2 class="frame-video" muted playsinline preload="auto">
        <source src="assets/videos/donation-overlay.webm" type="video/webm">
      </video>
    </div>

    <!-- КОНТЕНТ -->
    <div class="header-alert">
      <div class="user-name">{{alert()?.message?.username}}</div>
      <div class="divider">|</div>
      <div class="amount"><span style="font-size: 28px;">$</span>{{alert()?.message?.price}}</div>
    </div>

    <div class="message">
      {{alert()?.message?.text}}
    </div>

  </div>

</div>
